import { type PhoneNumber } from '@egw/api'

export enum UpdatePhoneStepEnum {
  CHANGE = 'CHANGE_PHONE',
  VERIFY = 'VERIFY_PHONE',
  CONFIRM = 'CONFIRM_PHONE',
  ERROR = 'ERROR',
}

export enum UpdatePhoneField {
  PHONE = 'PHONE',
  OTP_CODE = 'OTP_CODE',
}

export interface UpdatePhoneInput {
  code?: string
  getStatus?: boolean
  phone?: PhoneNumber
  resendVerification?: boolean
}

export interface UpdatePhoneStep {
  ctaOnClick: () => void
  isLoading: boolean
  resendCode: () => void
  closeModal: () => void
}

export interface UpdatePhoneForm {
  [UpdatePhoneField.PHONE]: string
  [UpdatePhoneField.OTP_CODE]: string
}
